<template>
    <div v-if="1==2" class=" header  header-border d-md-block ">
        <img class=" header-img" src="@/assets/header.png"/>
    </div>

</template>

<script>
import {
} from "@ionic/vue";
import { isPlatform } from '@ionic/vue';

export default {
  components: {
  },
  data() {
    return {
      isDesktop: null,
    }
  },
  computed: {
  },
  methods: {
 
  
  },
  async created() {
    this.isDesktop= isPlatform('desktop');
  }
};
</script>
<style lang="scss">

.header {
  border-bottom: 3px solid;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 10;
  background:white;
}

.header-img {
  width: 100%;
  height: 100%;
  max-width:800px;
  object-fit: cover;
  object-position: center;
}

</style>
